import axios from 'axios'
import cubeResponseCheck from '@/utils/axios-interceptor/cube-response-check'
import autoToken from '@/utils/axios-interceptor/auto-token'
import loadingVuex from '@/utils/axios-interceptor/loading-vuex'
import get from 'lodash.get'

const service = axios.create({
  timeout: 20 * 1000,
  headers: {
    'Content-Type': 'application/json',
    'charset': 'utf-8'
  }
})

// 这里的interceptors 是有顺序的
const interceptors = [autoToken, cubeResponseCheck, loadingVuex]
// const interceptors = [loadingFullscreen, authorizationCheck, cubeResponseCheck]
interceptors.forEach(interceptor => {
  interceptor(service)
})

// 最后一个interceptors 方便接口响应使用数据
// 针对未验证通过的reject Promise，抽取message.info 信息返回
service.interceptors.response.use(response => {
  return response.data
}, errorResponse => {
  // if (errorResponse.response.status === 401 && errorResponse.response.data.location) {
  //   window.location.href = errorResponse.response.data.location
  // }
  const errorMessage = get(errorResponse, 'data.message.info', errorResponse.data)
  return Promise.reject(errorMessage)
})

/**
 * 提供一个标准的请求基类
 * 已经具备的interceptor 有：
 * - 魔方标准响应码处理
 * - Bearer Token 检测和处理
 * - 全屏loading 功能
 * - vuex api loading 功能
 *
 * 如果在业务场景下不需要某项操作，或者基本配置不满足要求（比如默认超时时间）
 * 请新建request axios service，或者重新覆盖request config
 */
export default service



// WEBPACK FOOTER //
// ./src/utils/request-base.js